import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

import { getSelectedInsuranceOffers } from './getSelectedInsuranceOffers'

export function hasMonthlyInsuranceOfferSelected(
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
): boolean {
  const selectedInsuranceOffers = getSelectedInsuranceOffers(items)

  return (
    selectedInsuranceOffers.length > 0 &&
    selectedInsuranceOffers.some(
      (offer: InsuranceOfferWithSelectedState) => offer.isMonthly,
    )
  )
}
